import { useState, useEffect } from 'react'
import { Catalogue } from '@ynap/api-utils'
import { productSelectors } from '@ynap/product-state'

export const useProductListing = ({ path, options, locale, messages, globalConfig, imagesphereAspectRatio }) => {
    const { baseUrl, clientId } = globalConfig.services.commerce
    const { brandId } = globalConfig.application
    const { country, id } = locale
    const optionsToUse = { ...options, locale: locale.locale }

    const [products, setProducts] = useState([{}, {}, {}, {}, {}])
    const [loading, setLoading] = useState(true)
    const [error, setError] = useState(false)

    useEffect(() => {
        const request = Catalogue.getCategoryBySeoPath({ baseUrl, brandId, country, path, options: optionsToUse, clientId })
        setLoading(true)

        fetch(request)
            .then((res) => {
                if (!res.ok) {
                    setError(true)
                }
                return res.json()
            })
            .then((json) => {
                setProducts(mappedProducts(json.products, (locale = id), '', messages, imagesphereAspectRatio))
                setLoading(false)
            })
            .catch(() => {
                setError(true)
                setLoading(false)
            })
    }, [options.pageNumber])

    return {
        products,
        loading,
        error,
    }
}

export const mappedProducts = (products = null, locale, pageType, messages, imagesphereAspectRatio) => {
    if (!products) {
        return []
    }

    const { getMappedProduct } = productSelectors
    const pdpUrlTemplate = ''
    const badgeBlocklist = []
    const availableImageSizes = [300]
    const imageQuality = 80

    return products.filter(Boolean).map((product) => {
        return {
            ...getMappedProduct({
                id: product.productId,
                product,
                badgeBlocklist,
                locale,
                availableImageSizes,
                pdpUrlTemplate,
                imageQuality,
                pageType,
                messages,
                imagesphereAspectRatio,
            }),
            skuPartNumber: product?.productColours?.[0]?.partNumber,
            displayable: product?.visible,
            badge: undefined,
        }
    })
}
